import React from 'react';
import { Row, Col, Typography, Image, List } from 'antd';
import AboutUs1 from '../../assets/Images/Aboutus1.jpg'
import AboutUs2 from '../../assets/Images/aboutUS.jpg'

const { Title, Paragraph, Text } = Typography;

const AboutUs = () => {
  return (
    <div style={{ padding: '20px' }}>
      {/* ABOUT US Section */}
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} md={12}>
          <Title style={{color: '#4CA1AF'}} level={2}>
            ABOUT US
          </Title>
          <Paragraph className='text-para'>
            <Text className='text-para' strong>Maiyelan Exports</Text> is an emerging Exporter,
            Trader, Supplier of various Food Products in the market.
            Based at Tamil Nadu (India), our company was set up recently in
            2024. We are offering a variety of Vegetables, Spices, Rice, Coconut
            Shell Products, etc. We have deployed domain experts in our company
            to maintain all in-house activities in a proficient manner.
          </Paragraph>
          <Paragraph className='text-para'>
            Further, with our transparent deals and scheduled transportation of
            ordered goods gives us the valuable trust of our reputed clients.
          </Paragraph>
        </Col>
        <Col xs={24} md={12}>
          <Image
            src={AboutUs1}
            alt="Coconut"
            preview={false}
          />
        </Col>
      </Row>

      {/* WHY CHOOSE US Section */}
      <Row gutter={[16, 16]} align="middle">
      <Col xs={24} md={12}>
          <Image
            src={AboutUs2}
            alt="Coconut"
            preview={false}
          />
        </Col>
        <Col xs={24} md={12}>
        <Title style={{color: '#4CA1AF'}} className='text-para' level={3}>WHY CHOOSE US?</Title>
          <Paragraph className='text-para'>
            With the recent constitution of our company, we focus on each and
            every aspect of our products and services offered to our valuable
            clients.
          </Paragraph>
          <List
            dataSource={[
              'Ethical business practices',
              'Transparent deals',
              'Trusted vendor base',
              'Unmatched quality',
              'Excellent workforce',
              'Competitive price range',
              'Scheduled delivery',
              'Client satisfaction',
            ]}
            renderItem={(item) => (
              <List.Item>
                <Text>- {item}</Text>
              </List.Item>
            )}
          />
        </Col>
       
      </Row>
    </div>
  );
};

export default AboutUs;
